import React from 'react';

import type { SpacerProps } from '../layout.types';

export const Spacer: React.FC<SpacerProps> = ({ top = 0, right = 0, bottom = 0, left = 0 }) => (
  <div className={`mb-${bottom} ml-${left} mr-${right} mt-${top}`} />
);
